import { GameVars } from "./../../GameVars";
import { GameConstants } from "./../../GameConstants";

export class SplashBanan extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2 + 350 * GameVars.scaleX;
        this.y = 410;
        
        this.scaleX = GameVars.scaleX;

        const star = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "splash_star.png");
        this.add(star);

        this.scene.tweens.add({
            targets: star,
            scaleX: 1.1,
            scaleY: 1.1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 1500,
            repeat: -1,
            yoyo: true
        });

        const banana = new Phaser.GameObjects.Image(this.scene, 0, 90, "texture_atlas_1", "splash_banana_char.png");
        banana.setOrigin(.5, .9);
        banana.angle = -1;
        this.add(banana);

        this.scene.tweens.add({
            targets: banana,
            scaleX: 1.035,
            scaleY: .965,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 400,
            repeat: -1,
            yoyo: true
        });

        this.scene.tweens.add({
            targets: banana,
            angle: 1,
            ease: Phaser.Math.Easing.Quartic.In,
            duration: 1200,
            repeat: -1,
            yoyo: true
        });
    }
}
